<div class="grid grid-cols-2 grid-rows-1 gap-4">
    <div>
        <!-- Fix the ngFor trackBy usage. Use a component trackBy function instead of b?.id -->
        <div class="rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div class="flex items-center justify-between px-4 sm:px-5 py-3 border-b border-slate-100">
                <h5 class="text-slate-800 mb-0 font-semibold">Featured Blogs</h5>
                <span class="text-xs font-medium rounded-md bg-indigo-50 text-indigo-600 px-3 py-1"> {{ totalLabel }} </span>
            </div>

            <div>
                @for (b of blogs; track trackByBlogId($index, b)) {
                <div class="flex items-center justify-between px-4 sm:px-5 py-3 border-b last:border-b-0 border-slate-100">
                    <div class="flex items-center gap-4">
                        <div class="h-14 w-14 rounded-md overflow-hidden ring-1 ring-slate-200 bg-slate-50">
                            <img [src]="b.imagePath" [alt]="b.summary" class="h-full w-full object-cover" />
                        </div>
                        <div class="flex flex-col">
                            <button type="button" class="text-slate-800 font-semibold text-sm text-left hover:underline" (click)="openBlog(b)" [title]="b.link">{{ b.summary }}</button>
                            <div class="text-slate-500 text-sm truncate max-w-[22rem]">{{ b.author }}</div>
                            <div class="text-xs text-slate-400 mt-1">{{ formatDate(b.publishedAt) }}</div>
                        </div>
                    </div>
                    <div>
                        <button type="button" class="h-8 w-8 rounded-md bg-slate-50 hover:bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-500" (click)="openBlog(b)" aria-label="Open">
                            <i class="pi pi-chevron-right text-xs"></i>
                        </button>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
    <div>
        <!-- Fix the ngFor trackBy usage. Use a component trackBy function instead of b?.id -->
        <!-- <div class="rounded-2xl border border-slate-200 bg-white shadow-sm">
    <div class="flex items-center justify-between px-4 sm:px-5 py-3 border-b border-slate-100">
      <h5 class="text-slate-800 mb-0 font-semibold">Other Documents</h5>
    </div>

    <div>
    </div>
  </div> -->
    </div>
</div>
